import { useContext } from 'react'
import { useMutation, useQuery } from 'react-query'
import { apiPatch, apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getIssueLogs = async (token, issueId, params) => {
  const url = `issues/${issueId}/logs`
  const data = await apiGet({ url, token, params })
  return data
}

export function useIssueLogs({ params, issueId, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getIssueLogs(token, issueId, params)
  const queryKey = ['issue-logs', issueId, params]
  return useQuery(queryKey, queryFn, { ...options })
}

const updateIssueLog = async (token, params) => {
  const objectName = 'municipality_issue_log'
  const url = `logs/${params.id}`

  return apiPatch({ url, token, objectName, params })
}

export function useUpdateIssueLog({ params, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    () => {
      return updateIssueLog(token, params)
    },
    { ...options }
  )
}
